function rizonInitFiltersDialog() {
  const dialog = document.getElementById('RizonFiltersDialog');
  if (!dialog || dialog.dataset.rizonBound) return;
  dialog.dataset.rizonBound = 'true';

  const form = document.getElementById('FacetFiltersForm');
  let lastFocused = null;
  let snapshot = null;

  // Captures which boxes are checked and what the price inputs currently
  // hold - the baseline to revert to if the dialog is closed without
  // pressing Apply.
  function captureSnapshot() {
    if (!form) return null;
    const checkboxes = new Map();
    form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkboxes.set(checkbox, checkbox.checked);
    });
    const priceInputs = new Map();
    form.querySelectorAll('.rizon-filters-dialog__price-field input').forEach((input) => {
      priceInputs.set(input, input.value);
    });
    return { checkboxes, priceInputs };
  }

  function restoreSnapshot(snap) {
    if (!snap) return;
    snap.checkboxes.forEach((checked, checkbox) => {
      checkbox.checked = checked;
    });
    snap.priceInputs.forEach((value, input) => {
      input.value = value;
    });
    dialog.querySelectorAll('rizon-price-slider').forEach((slider) => slider.syncFromInputs?.());
    updateReactiveState();
  }

  function onKeyDown(event) {
    if (event.key === 'Escape') closeDialog();
  }

  function openDialog() {
    lastFocused = document.activeElement;
    snapshot = captureSnapshot();
    dialog.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    dialog.querySelector('.rizon-filters-dialog__close')?.focus();
    document.addEventListener('keydown', onKeyDown);
    // Lets assets/rizon-animations.js stagger the filter groups in -
    // purely additive, doesn't touch the panel's own CSS slide-in above.
    dialog.dispatchEvent(new CustomEvent('rizon:modal-opened', { bubbles: true }));
  }

  // X, backdrop click, or ESC - discards any checked/typed-but-unapplied
  // changes, reverting to whatever was actually applied when the dialog
  // opened (checking a box no longer filters anything by itself; see the
  // Apply-gating below).
  function closeDialog() {
    restoreSnapshot(snapshot);
    dialog.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeyDown);
    lastFocused?.focus();
  }

  // Apply: commits the current control state as a real filter change by
  // dispatching a genuine 'input' event directly on the form, which is
  // exactly what Dawn's own FacetFiltersForm listens for to trigger its
  // (unmodified) debounced AJAX submit - then closes without reverting.
  function applyDialog() {
    form?.dispatchEvent(new Event('input', { bubbles: true }));
    snapshot = captureSnapshot();
    dialog.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeyDown);
    lastFocused?.focus();
  }

  document.querySelectorAll('[data-filters-open]').forEach((button) => {
    button.addEventListener('click', openDialog);
  });

  dialog.querySelectorAll('[data-filters-close]').forEach((button) => {
    button.addEventListener('click', closeDialog);
  });

  document.getElementById('RizonFiltersApply')?.addEventListener('click', applyDialog);

  // #RizonFiltersDialog sits outside #ProductGridContainer, so nothing in
  // here is ever touched by facets.js's AJAX section swap - a
  // Liquid-computed "is this filter active" state (used for the Clear all
  // button and each group's own Remove link) goes stale the instant a box
  // is toggled without a full page reload. Recompute it from the live form
  // on every change instead.
  function groupIsActive(details) {
    if (details.dataset.filterType === 'price_range') {
      const slider = details.querySelector('rizon-price-slider');
      return !!slider && (slider.inputMin?.value !== '' || slider.inputMax?.value !== '');
    }
    return details.querySelector('input[type="checkbox"]:checked') !== null;
  }

  function resetGroup(details) {
    if (details.dataset.filterType === 'price_range') {
      details.querySelectorAll('rizon-price-slider').forEach((slider) => slider.reset?.());
    } else {
      details.querySelectorAll('input[type="checkbox"]:checked').forEach((checkbox) => {
        checkbox.checked = false;
      });
    }
  }

  function updateReactiveState() {
    if (!form) return;
    let anyActive = false;

    dialog.querySelectorAll('.rizon-filters-dialog__group').forEach((details) => {
      const active = groupIsActive(details);
      if (active) anyActive = true;
      details
        .querySelector('[data-group-remove]')
        ?.classList.toggle('rizon-filters-dialog__group-remove--hidden', !active);
    });

    dialog
      .querySelector('[data-clear-all]')
      ?.classList.toggle('rizon-filters-dialog__clear--inactive', !anyActive);
  }

  if (form) {
    // Checking a box or dragging the price slider should only stage a
    // change, not filter anything until Apply is pressed - but Dawn's own
    // FacetFiltersForm (facets.js, unmodified) listens for 'input' at the
    // form level and auto-submits 800ms after any such event reaches it.
    // stopPropagation here keeps that event from ever reaching the form
    // (it's attached directly on each control, so it fires before the
    // event would otherwise bubble that far) - updateReactiveState still
    // runs so the Remove/Clear all buttons reflect staged-but-unapplied
    // changes immediately. Apply's synthetic form-level dispatch above is
    // the only thing that actually reaches Dawn's listener now.
    const stageChange = (event) => {
      event.stopPropagation();
      updateReactiveState();
    };
    form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.addEventListener('input', stageChange);
      checkbox.addEventListener('change', (event) => event.stopPropagation());
    });
    form.querySelectorAll('.rizon-filters-dialog__price-field input').forEach((input) => {
      input.addEventListener('input', stageChange);
      input.addEventListener('change', (event) => event.stopPropagation());
    });

    // Clear all and a group's own Remove stay immediate (not gated behind
    // Apply) - they're already explicit "do this now" actions that go
    // through facet-remove's real AJAX navigation. Re-capture the snapshot
    // afterward so a subsequent close-without-Apply doesn't undo them.
    dialog.querySelector('[data-clear-all] a')?.addEventListener('click', () => {
      dialog.querySelectorAll('.rizon-filters-dialog__group').forEach(resetGroup);
      updateReactiveState();
      snapshot = captureSnapshot();
    });

    // Same idea for a single group's own "Remove" link - it lives inside
    // <summary>, so its click bubbles up to the accordion's own click
    // handler below and would otherwise also toggle the group open/closed.
    dialog.querySelectorAll('[data-group-remove]').forEach((removeEl) => {
      const details = removeEl.closest('.rizon-filters-dialog__group');
      removeEl.querySelector('a')?.addEventListener('click', (event) => {
        event.stopPropagation();
        if (details) resetGroup(details);
        updateReactiveState();
        snapshot = captureSnapshot();
      });
    });
  }

  // Smooth, interruptible accordion expand/collapse via the Web Animations
  // API - a plain CSS transition (max-height or grid-template-rows, both
  // tried first) can't be interrupted mid-flight, so a second click while
  // one was still running either got ignored or re-started from the wrong
  // point, which read as laggy/unresponsive under quick clicking. WAAPI
  // gives a real, cancellable Animation object instead: clicking again
  // mid-animation measures the current live height and reverses smoothly
  // from exactly there, every time.
  dialog.querySelectorAll('.rizon-filters-dialog__group').forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    const wrapper = details.querySelector(':scope > .rizon-filters-dialog__group-content-wrapper');
    if (!summary || !wrapper) return;

    let currentAnimation = null;
    // What the user last asked for - NOT the same thing as details.open,
    // which native <details> only flips to false once a closing animation
    // actually finishes. Using details.open here to decide the next click's
    // direction was the bug: it stays true for the entire duration of a
    // closing animation, so a 3rd rapid click (while the 2nd click's close
    // was still mid-flight) read the group as "still open" and closed it
    // again instead of reopening.
    let targetOpen = false;

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      const opening = !targetOpen;
      targetOpen = opening;

      // Always measure live: 0 for a never-opened (display: none) group,
      // the current interpolated value mid-animation, or the natural
      // resting height when fully open - getBoundingClientRect() is
      // correct in all three cases with no extra branching needed.
      const startHeight = wrapper.getBoundingClientRect().height;

      if (opening && !details.open) details.open = true;
      const endHeight = opening ? wrapper.scrollHeight : 0;

      currentAnimation?.cancel();
      wrapper.style.overflow = 'hidden';
      const animation = wrapper.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: 250, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' },
      );
      currentAnimation = animation;

      animation.finished
        .then(() => {
          wrapper.style.overflow = '';
          wrapper.style.height = '';
          if (!opening) details.open = false;
          if (currentAnimation === animation) currentAnimation = null;
        })
        .catch(() => {
          // Cancelled by a follow-up click before finishing - the new
          // animation created above already owns the wrapper's state.
        });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', rizonInitFiltersDialog);
} else {
  rizonInitFiltersDialog();
}

document.addEventListener('shopify:section:load', rizonInitFiltersDialog);
